import { cloneDeep } from 'lodash'

import { generateServices, globalErrorHandler, services, states } from '@/utils'

import render from './render'

const prefix = title => {
  return `[DIRECT] ${title}`
}

const defaultFilter = {
  type: undefined,
  title: undefined,
  isActive: true
}

export default {
  name: 'RoutesCreateDirect',

  mixins: [
    generateServices([
      {
        name: services.routingGroups,

        disableWatchers: true,

        find: {
          defaultFilter: cloneDeep(defaultFilter)
        },

        get: false,
        update: false,
        remove: false
      },
      {
        name: services.routingRules,

        find: false,
        get: false,
        update: false,
        remove: false
      },
      {
        name: services.providerGroups,

        find: false,
        get: false,
        update: false,
        remove: false
      },
      {
        name: services.providers,

        find: false,
        create: false,
        update: false,
        remove: false
      }
    ])
  ],

  props: {
    value: Boolean,
    type: String
  },

  data() {
    return {
      provider: undefined,
      providerTitle: undefined,

      responsibility: false
    }
  },

  computed: {
    loading() {
      return this.restData.routingGroups.create.state === states.loading ||
      this.restData.routingRules.create.state === states.loading ||
      this.restData.providerGroups.create.state === states.loading ||
      this.restData.providers.get.state === states.loading
    },
    disabled() {
      return this.restData.routingGroups.find.pagination.total > 0 && !this.responsibility || this.loading || !this.provider
    }
  },

  watch: {
    async provider() {
      if (this.provider) {
        const { title } = await this.rest.providers.get(this.provider)
        this.providerTitle = title
        this.restData.routingGroups.find.filter.type = this.type
        this.restData.routingGroups.find.filter.title = `[DIRECT] ${title}`
        this.rest.routingGroups.find()
      }
    }
  },

  mounted() {
    this.clear()
  },

  beforeDestroy() {
    this.clear()
  },

  methods: {
    clear() {
      this.provider = undefined
      this.providerTitle = undefined
      this.restData.routingGroups.find.data = undefined
      this.restData.routingGroups.find.state = states.empty
      this.restData.routingGroups.find.filter = cloneDeep(defaultFilter)
    },

    async create() {
      try {
        const providerGroup = await this.rest.providerGroups.create({
          title: prefix(this.providerTitle),
          type: this.type,
          Providers: [
            {
              id: this.provider,
              priority: 0,
              $attach: true
            }
          ]
        })
        const routingRule = await this.rest.routingRules.create({
          title: prefix(this.providerTitle),
          type: this.type,
          ProviderGroups: [
            {
              id: providerGroup.id,
              percentage: 100,
              $attach: true
            }
          ]
        })
        const routingGroup = await this.rest.routingGroups.create({
          title: prefix(this.providerTitle),
          type: this.type,
          RoutingRules: [
            {
              id: routingRule.id,
              priority: 0,
              $attach: true
            }
          ]
        })
        this.$emit('input', routingGroup.id)
      } catch (error) {
        globalErrorHandler(error)
      } finally {
        this.clear()
        this.$emit('showDialog', false)
      }
    }
  },

  render
}
